import { render, staticRenderFns } from "./ConfirmDialogue.vue?vue&type=template&id=4240460a&scoped=true&"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialogue.vue?vue&type=style&index=0&id=4240460a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240460a",
  null
  
)

export default component.exports